import { AgencyMasterProperties } from "./AgencyMasterProperties";
import { TelephonePassengerProperties } from "./BookingPassengerTicketIssuanceProperties";
import { UsersProperties } from "./UsersProperties";

export class OfflineBookingNewProperties {
  offlineBookingId: number | null;
  exchangeCurrencyRate: number | null;
  issuingAirline: string | null;
  bookingSource: string | null;
  isManager: boolean;
  pnr: string | null;
  journeyTypeId: number | null;
  agency_Branch_Id: string | null;
  isApproved: boolean;
  isDeleted: boolean;
  creationUser: number | null;
  modifyUser: number | null;
  remarks: string | null;
  creationDate: string | null;
  modifyDate: string | null;
  status: number | null;
  sector: string | null;
  offlineRequestTypeId: number | null;
  travelDate: string | null;
  route: string | null;
  baseFare: number | null;
  amount: number | null;
  serviceCharges: number | null;
  netTotalAmount: number | null;
  approve_Reject_User: number | null;
  passName: string | null;
  ticketNo: string | null;
  onlineBookingId: number | null;
  inProgress: boolean;
  ticketReRequest: boolean;
  reRequestAgencyId: string | null;
  bookingPcc: string | null;
  supplierCurrency: string | null;
  providerCode: string | null;
  fareRulesDetails: string | null;
  generalRules: string | null;
  offlineBookingRequestId: number | null;
  refundType: string | null;
  agencyBranchManagerId: number | null;
  agencyCurrency: string | null;
  parentHierarchy: string | null;
  taxes: number | null;
  netToCustomer: number | null;
  netFromSupplier: number | null;
  refundCharges: number | null;
  offlinePassengerList: OfflineBookingNewPassengerDetails[];
  tripList: OfflineTripDetailsNew[];
  filePaths: string[];
  userObj = new UsersProperties();
  agencyMasterObj = new AgencyMasterProperties;
}

export class OfflineBookingNewPassengerDetails {
  offlineBookingId: number;
  offlineBookingPassengerId: number;
  title: string;
  firstName: string;
  lastName: string;
  passengerTypeId: number;
  nationality: string;
  passportNo: string;
  isDeleted: boolean;
  creationUser: number;
  creationDateTime: string;
  modifyUser: number;
  modifyDateTime: string;
  paxGender: string;
  countryOfIssuance: string;
  paxDOB: string;
  mobileNo: string;
  passportValidTo: string;
  emailId: string;
  frequentFlyerNo: string;
  fare: number;
  discount: number;
  tax: number;
  payable: number;
  ticketNo: string;
  issuancePcc: string;
  bookingPcc: string;
  supplierCode: string;
  agencyBranch: string;
  supplierCurrencyId: number;
  supplierCurrency: string;
  agencyCurrency: string;
  serviceCharges: number | null;
  profit: number | null;
  netFromCustomer: number | null;
  netToSupplier: number | null;
  markup: number | null;
  commissionForSupplier: number | null;
  netTotalAmount: number | null;
  backSystemSupplierServiceId: number | null;
  backSystemCustomerServiceId: number | null;
  exchangeCurrencyRate: number | null;
  telephoneList = new TelephonePassengerProperties();
}


export class ResponseToClient {
  message: string = "";
  success: boolean = false;
  data: string = "";
}
export class OfflineSuppliersCombine {
  supplierName: string = "";
  supplierCode: string = "";
}
export class OfflineTripDetailsNew {
  tripId: number;
  fromAirport: string;
  toAirport: string;
  offlineBookingId: number | null;
  travelingDate: string;
  rBD: string;
  travellingClass: string;
  creationUser: number | null;
  creationDateTime: string | null;
  modifyUser: number | null;
  modifyDateTime: string | null;
  passengerId: number;
  flightNumber: string;
  segmentType: number;
  departureSegment: boolean;
  returnSegment: boolean;
  multicitySegment: boolean;
  departureTime: string;
  arrivalDate: string | null;
  arrivalTime: string;
  airlineName: string;
  aircraft: string;
}
